import { dateTypeMap, dateFormatMap } from '@/pages/opinion/constants';
import {
  defaultTo,
  dealwithLanguage,
  formatTime,
  sentimentNumber,
  toPercentNumber,
  tryTransNumberDefaultLine,
  tryTransNumber,
  brandHealthRenderHelper,
} from '../../render-helper';
import { brandHealthFormat } from '@op/utils/value';

function getRegionCountryData(type: 'region' | 'country') {
  const countryRegion = JSON.parse(
    localStorage.getItem('countryRegion') || '{}',
  );

  return (item) => {
    const originKey = item.country;
    if (originKey === 'global') return 'Global';
    const regionLowerKey = originKey?.toLocaleLowerCase?.();
    const regionUpperKey = originKey?.toLocaleUpperCase?.();
    const data =
      countryRegion[regionLowerKey] ||
      countryRegion[regionUpperKey] ||
      countryRegion[originKey];

    return type === 'region' ? data?.region_name_en : data?.country_name_en;
  };
}
export default function keyMetricsColumns(params: any) {
  const { group_bys = [], metrics = [], entity_type, date_type } = params || {};
  const dateType = dateTypeMap[date_type];
  const groupBysColumns = {
    time: [
      {
        renderHelper: [formatTime(dateFormatMap[dateType])],
        header: 'Date',
        render: 'time',
      },
    ],
    channel: [
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Channel',
        render: 'channel',
      },
    ],
    country: [
      {
        renderHelper: [getRegionCountryData('country')],
        header: 'Country',
        render: 'country',
      },
      {
        renderHelper: [getRegionCountryData('region')],
        header: 'Region',
        render: 'region',
      },
    ],
    language: [
      {
        renderHelper: [dealwithLanguage],
        header: 'Language',
        render: 'language',
      },
    ],
    sentiment: [
      {
        header: 'Sentiment',
        render: 'sentiment',
        renderHelper: [sentimentNumber],
        numFmt: ['0.0'],
      },
    ],
    rating: [
      {
        header: 'Reviews Rating',
        render: 'rating',
        renderHelper: [defaultTo('-')],
      },
    ],
  };
  const metricsColumns = {
    account_posts: [
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Account Post',
        render: 'account_posts',
      },
    ],
    engagement: [
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Engagement Sum',
        render: 'engagement',
      },
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Share',
        render: 'shares',
      },
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Comment',
        render: 'comments',
      },
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Like',
        render: 'likes',
      },
      // { renderHelper: [tryTransNumberDefaultLine], header: 'Views' , render: 'views' },
      // { renderHelper: [tryTransNumberDefaultLine], header: 'Followers' , render: 'followers' },
    ],
    // avg_sentiment: [
    //   {
    //     renderHelper: [tryTransNumberDefaultLine],
    //     header: 'Avg Sentiment',
    //     render: 'avg_sentiment',
    //     numFmt: ['0.00'],
    //   },
    // ],
    avg_sentiment: [
      {
        header: 'Sentiment',
        render: 'net_sentiment',
        renderHelper: [sentimentNumber],
        numFmt: ['0.00'],
      },
    ],
    brand_health: [
      {
        renderHelper: [tryTransNumber, brandHealthRenderHelper],
        header: 'Brand Health',
        render: 'brand_health',
        numFmt: ['0'],
      },
    ],
    mentions: [
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Mentions',
        render: 'mentions',
      },
    ],
    non_negative_ratio: [
      {
        renderHelper: [tryTransNumberDefaultLine],
        header: 'Non Negative%',
        render: 'non_negative_ratio',
        numFmt: '0.00%',
      },
    ],
    user_score: {
      common: [
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected Reviews',

          render: 'user_score_select_mentions',
        },
      ],
      mobile: [
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected User Score',
          render: 'user_score_select_score',
          numFmt: ['0.0'],
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          numFmt: ['0.0'],
          header: 'Lifetime User Score',
          render: 'user_score_lifetime_mobile_score',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Lifetime Reviews',
          render: 'user_score_lifetime_mobile_mentions',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected 1 Stars',
          render: 'user_score_select_1_stars_mentions',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected 2 Stars',
          render: 'user_score_select_2_stars_mentions',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected 3 Stars',
          render: 'user_score_select_3_stars_mentions',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected 4 Stars',
          render: 'user_score_select_4_stars_mentions',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected 5 Stars',
          render: 'user_score_select_5_stars_mentions',
        },
      ],
      pcConsole: [
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'All Reviews',
          render: 'user_score_lifetime_all_review',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          numFmt: '0.00%',
          header: 'All Reviews Positive %',
          render: 'user_score_lifetime_all_review_positive',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Selected reviews positive %',
          render: 'user_score_select_positive_rate',
          numFmt: '0.00%',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Top Critic Score',
          render: 'user_score_lifetime_top_critic_score',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Top Critic Review',
          render: 'user_score_lifetime_top_critic_review',
        },
        {
          renderHelper: [toPercentNumber()],
          header: 'Recommend%',
          render: 'user_score_lifetime_recommend',
          numFmt: '0.00%',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Recommend Reviews',
          render: 'user_score_lifetime_recommend_view',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Metascore',

          render: 'user_score_lifetime_metascore',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'Metascore Reviews',
          render: 'user_score_lifetime_metascore_review',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'User Score',

          render: 'user_score_lifetime_score',
        },
        {
          renderHelper: [tryTransNumberDefaultLine],
          header: 'User Score Ratings',
          render: 'user_score_lifetime_mentions',
        },
      ],
    },
  };

  const commonColumns: any = [];
  const group_bys_columns = group_bys.map((item) => groupBysColumns[item]);
  const metrics_columns = metrics.map((item) => {
    const data = metricsColumns[item];
    if (item === 'user_score') {
      const key = entity_type === 'mobile' ? 'mobile' : 'pcConsole';
      return [...data.common, ...data[key]];
    }
    return data;
  });
  if (entity_type === 'console') {
    commonColumns.push({
      renderHelper: [tryTransNumberDefaultLine],
      header: 'Platform',
      render: 'user_score_lifetime_device',
    });
  }

  const sortKeys = [
    'user_score_lifetime_device',
    'time',
    'channel',
    'sentiment',
    'net_sentiment',
    'brand_health',
    'language',
    'region',
    'country',
    'rating',
    'mentions',
    'account_posts',
    'engagement',
    'likes',
    'comments',
    'shares',
    // 'views',
    // 'followers',
    'avg_sentiment',
    'non_negative_ratio',
    'user_score_lifetime_mobile_score',
    'user_score_lifetime_mobile_mentions',
    'user_score_select_score',
    'user_score_select_mentions',
    'user_score_select_1_stars_mentions',
    'user_score_select_2_stars_mentions',
    'user_score_select_3_stars_mentions',
    'user_score_select_4_stars_mentions',
    'user_score_select_5_stars_mentions',
    'user_score_select_positive_rate',
    'user_score_lifetime_all_review',
    'user_score_lifetime_all_review_positive',
    'user_score_lifetime_top_critic_score',
    'user_score_lifetime_top_critic_review',
    'user_score_lifetime_recommend',
    'user_score_lifetime_recommend_view',
    'user_score_lifetime_metascore',
    'user_score_lifetime_metascore_review',
    'user_score_lifetime_score',
    'user_score_lifetime_mentions',
  ];

  // 拼装，过滤， 拍平，排序
  return commonColumns
    .concat(group_bys_columns, metrics_columns)
    .filter(Boolean)
    .flat(Infinity)
    .sort((a, b) => sortKeys.indexOf(a.render) - sortKeys.indexOf(b.render));
}
